<template>
  <div>
    <el-dialog
      title="填写通过信息"
      :visible.sync="showLastNodePassDialog"
      :width="approveForm.relevance ? '70%' : '40%'"
      top="5%"
    >
      <el-form ref="formRef" :model="approveForm" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="14">
            <el-form-item label-width="111px">
              <span slot="label">
                <span style="color: red">*</span>是否开票：
              </span>
              <el-select
                class="fl"
                size="mini"
                v-model="isInvoiced"
                placeholder="是否开票"
              >
                <el-option label="是" value="Y"></el-option>
                <el-option label="否" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="!paymentSettleList?.length">
            <el-form-item label-width="110px" class="t-left">
              <span slot="label">
                <span style="color: red">*</span>关联流程：
              </span>
              <el-input
                style="width: 380px"
                v-model="approveForm.relevance"
                placeholder="请选择关联流程"
                readonly
                @focus="focusRelevance"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="14" v-if="isInvoiced == 'N'">
            <el-form-item label-width="110px" class="t-left">
              <span slot="label">
                <span style="color: red">*</span>结算单上传：
              </span>
              <el-upload
                class="upload-demo t-left"
                action="#"
                ref="settleAttaches"
                :on-preview="onPreview"
                :file-list="approveForm.settleAttaches"
                accept=".xlsx,.docx,.doc,.pdf,.zip"
                :auto-upload="true"
                :http-request="changeMainFile"
                :limit="20"
                :on-exceed="handleMainExceed"
              >
                <div
                  class="flex items_center"
                  slot="file"
                  slot-scope="{ file }"
                  style="width: 460px"
                >
                  <div class="w300">
                    {{ formatFileName(file.fileName) }}
                  </div>
                  <div>
                    <el-button
                      type="text"
                      class="file-preview"
                      @click="handleMainRemove(file)"
                      >删除
                    </el-button>

                    <el-button
                      type="text"
                      class="file-preview"
                      @click="onPreview(file)"
                      >查看
                    </el-button>

                    <el-button
                      type="text"
                      class="file-preview"
                      @click="download(file.path, file.name, file.fileName)"
                      >下载
                    </el-button>
                  </div>
                </div>
                <el-button
                  size="mini"
                  icon="el-icon-my-import"
                  style="margin-top: 8px; margin-bottom: 0"
                  type="importNew"
                  >导入文件</el-button
                >
              </el-upload>
              <div class="import-step-tip">
                当前支持word、excel、pdf、zip、rar文件，单个文件大小≤{{
                  fileSize
                }}M
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" v-if="approveForm.relevance && isInvoiced == 'Y'">
          <el-col :span="16">
            <div
              v-for="(item, index) in approveForm.settleDetail"
              :key="item.taskTypeGuid"
            >
              <div class="form-title-item">票据信息 {{ index + 1 }}</div>

              <el-row :gutter="24">
                <el-col :span="10">
                  <el-form-item label-width="150px" class="t-left">
                    <span slot="label">
                      <span style="color: red">*</span>任务大类：
                    </span>
                    <span>
                      {{ item.taskType }}
                    </span>
                  </el-form-item>
                </el-col>

                <el-col :span="10">
                  <el-form-item label-width="150px" class="t-left">
                    <span slot="label">
                      <span style="color: red">*</span>开票金额(元)：
                    </span>
                    <span>
                      {{ item.totalAmount | numDigit }}
                    </span>
                  </el-form-item>
                </el-col>

                <el-col :span="4">
                  <el-form-item label-width="100px" class="t-left">
                    <span slot="label">
                      <span style="color: red">*</span>发票类目：
                    </span>
                    <el-select
                      size="small"
                      v-model="item.invoiceCategory"
                      placeholder="请选择"
                      filterable
                      class="w240"
                    >
                      <el-option
                        v-for="item in getCodeListByKey('发票类目')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <el-form-item label-width="150px" class="t-left">
                    <span slot="label">
                      <span style="color: red">*</span>结算单上传：
                    </span>
                    <el-upload
                      class="upload-demo t-left"
                      action="#"
                      :ref="`settleAttaches_${index}`"
                      :on-preview="onPreview"
                      :file-list="item.settleAttaches"
                      accept=".xlsx,.docx,.doc,.pdf,.zip,.rar,.ofd"
                      :auto-upload="true"
                      :http-request="
                        (file) =>
                          changeSubFile(file, item, index, 'settleAttaches')
                      "
                      :limit="1"
                      :on-exceed="handleSubExceed"
                    >
                      <div
                        class="flex items_center w420"
                        slot="file"
                        slot-scope="{ file }"
                      >
                        <div class="w240">
                          {{ formatFileName(file.fileName) }}
                        </div>

                        <div>
                          <el-button
                            type="text"
                            class="file-preview"
                            @click="
                              handleSubRemove(file, index, 'settleAttaches')
                            "
                            >删除
                          </el-button>

                          <el-button
                            type="text"
                            class="file-preview"
                            @click="onPreview(file)"
                            >查看
                          </el-button>

                          <el-button
                            type="text"
                            class="file-preview"
                            @click="
                              download(file.path, file.name, file.fileName)
                            "
                            >下载
                          </el-button>
                        </div>
                      </div>
                      <el-button
                        size="mini"
                        icon="el-icon-my-import"
                        style="margin-top: 8px; margin-bottom: 0"
                        type="importNew"
                        >导入文件</el-button
                      >
                    </el-upload>
                    <div class="import-step-tip">
                      当前支持word、excel、pdf、zip、rar、ofd文件，单个文件大小≤{{
                        fileSize
                      }}M
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="5" class="ml10">
                  <el-form-item label-width="150px" class="t-left">
                    <span slot="label">
                      <span style="color: red">*</span>票据上传：
                    </span>
                    <el-upload
                      class="upload-demo t-left"
                      action="#"
                      :ref="`invoiceAttaches_${index}`"
                      :on-preview="onPreview"
                      :file-list="item.invoiceAttaches"
                      accept=".xlsx,.docx,.doc,.pdf,.zip,.rar,.ofd"
                      :auto-upload="true"
                      :http-request="
                        (file) =>
                          changeSubFile(file, item, index, 'invoiceAttaches')
                      "
                      :limit="1"
                      :on-exceed="handleSubExceed"
                    >
                      <div
                        class="flex items_center w420"
                        slot="file"
                        slot-scope="{ file }"
                      >
                        <div class="w240">
                          {{ formatFileName(file.fileName) }}
                        </div>

                        <div>
                          <el-button
                            type="text"
                            class="file-preview"
                            @click="
                              handleSubRemove(file, index, 'invoiceAttaches')
                            "
                            >删除
                          </el-button>

                          <el-button
                            type="text"
                            class="file-preview"
                            @click="onPreview(file)"
                            >查看
                          </el-button>

                          <el-button
                            type="text"
                            class="file-preview"
                            @click="
                              download(file.path, file.name, file.fileName)
                            "
                            >下载
                          </el-button>
                        </div>
                      </div>
                      <el-button
                        size="mini"
                        icon="el-icon-my-import"
                        style="margin-top: 8px; margin-bottom: 0"
                        type="importNew"
                        >导入文件</el-button
                      >
                    </el-upload>
                    <div class="import-step-tip">
                      当前支持word、excel、pdf、zip、rar、ofd文件，单个文件大小≤{{
                        fileSize
                      }}M
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="24" v-if="isInvoiced == 'Y'">
          <el-col :span="14">
            <el-form-item label-width="110px" class="t-left">
              <span slot="label">
                <span style="color: red">*</span>开票时间：
              </span>
              <el-date-picker
                style="width: 200px"
                v-model="approveForm.invoiceDate"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择开票时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="14" v-if="isInvoiced == 'Y'">
            <el-form-item label-width="111px" class="t-left">
              <span slot="label">
                <span style="color: red">*</span>发票税率(%)：
              </span>
              <el-input
                style="width: 200px"
                type="text"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                maxlength="5"
                v-model="approveForm.taxRate"
                placeholder="请填写税率"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="14">
            <el-form-item label-width="110px" class="t-left">
              <span slot="label">
                <span style="color: white">*</span>备注说明：
              </span>
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请填写通过备注（选填）"
                v-model="approveForm.approveSuggest"
                maxlength="200"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" class="w240" @click="submitForm"
          >审批通过</el-button
        >
      </div>
    </el-dialog>
    <RelatedStatementDialog
      ref="relatedStatementDialog"
      :operationReportTenantGuid="operationReportTenantGuid"
      @close="closeRelatedStatementDialog"
      @select="handleSelectProcess"
    />
  </div>
</template>

<script>
import { download } from "@/uilt/download";
import RelatedStatementDialog from "./RelatedStatementDialog.vue";

export default {
  name: "LastNodePassDialog",
  components: {
    RelatedStatementDialog,
  },
  props: {
    onChangeFullscreenLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      download, //下载时保留文件名
      searchKey: "",
      approveForm: {
        approveSuggest: null,
        invoiceDate: null,
        settleAttaches: [], //结算
        invoiceAttaches: [], // 票据
        settleDetail: [],
        taxRate: null,
        relevance: null,
      },
      approveVO: {},
      fileSize: serverConfig.FILE_SIZE,
      isInvoiced: "Y",

      showLastNodePassDialog: false,
      serviceTenantGuid: "",
      selectSettDoc: [],
      parentBillType: "",
      operationReportTenantGuid: "",
      paymentSettleList: [],
    };
  },
  methods: {
    closeRelatedStatementDialog() {
      this.showLastNodePassDialog = true;
    },
    focusRelevance() {
      this.$refs.relatedStatementDialog.open();
      this.showLastNodePassDialog = false;
    },
    /**
     * 处理选择关联流程
     */
    async handleSelectProcess(data) {
      this.showLastNodePassDialog = true;
      const { relevanceText, totalPayable, selectSettDoc } = data;
      this.approveForm.relevance = relevanceText;
      this.selectSettDoc = selectSettDoc;
      const guids = selectSettDoc.map((item) => item.guid);
      const { data: resData } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/downstream/statement/detail-list`,
        guids
      );
      if (resData.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(resData.msg);
        return;
      }
      this.approveForm.settleDetail = resData.data.settleDetail;
    },
    async getSettleDetail() {
      const guids = this.paymentSettleList?.map((item) => item.settleGuid);
      let url = `/downstream/settle/detail-list`;
      if (this.parentBillType == 3) {
        // 证明提交的时候 用的是对账单提交的
        url = "/downstream/statement/detail-list";
      }
      this.onChangeFullscreenLoading(true);
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}${url}`,
        guids
      );
      this.onChangeFullscreenLoading(false);
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.approveForm = {
        ...this.approveForm,
        settleDetail: data.data.settleDetail,
        relevance: `${data.data.applyStaffName}`,
      };
    },
    async open(data) {
      this.serviceTenantGuid = data.serviceTenantGuid;
      this.approveForm = data.approveForm;
      this.approveVO = data.approveVO;
      this.paymentSettleList = data.paymentSettleList;
      this.parentBillType = data.parentBillType;
      this.operationReportTenantGuid = data.operationReportTenantGuid;
      if (this.paymentSettleList?.length) {
        await this.getSettleDetail();
      }
      this.showLastNodePassDialog = true;
    },

    changeSubFile(file, item, index, dataName) {
      const maxSize = file.file.size / 1024 / 1024 < this.fileSize;
      if (!maxSize) {
        this.$message.error(`上传文件大小不能超过${this.fileSize}MB`);
        const refName = `${dataName}_${index}`;
        if (
          this.$refs[refName] &&
          this.$refs[refName][0] &&
          this.$refs[refName][0].clearFiles
        ) {
          this.$refs[refName][0].clearFiles();
        }
        return;
      }
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("fileName", file.file.name);
      this.onChangeFullscreenLoading(true);
      this.api
        .postImage(
          `/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`,
          formData
        )
        .then((res) => {
          this.onChangeFullscreenLoading(false);
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (!this.approveForm.settleDetail[index][dataName]) {
              this.approveForm.settleDetail[index][dataName] = [];
            }

            // el-upload 上传文件只会保留文件基本信息 在这里特殊处理了一下
            const fileObj = {
              name: item.taskType, // el 上传文件的name 是文件的name 后端需要的是这个 name
              fileName: file.file.name,
              path: res.data.data.data,
              amount: item.totalAmount,
              status: "success",
              uid: file.file.uid, // 保持相同的 UID
              batchGuid: item.batchGuid,
            };

            this.approveForm.settleDetail[index][dataName].push(fileObj);

            this.$nextTick(() => {
              if (
                this.$refs[`${dataName}_${index}`] &&
                this.$refs[`${dataName}_${index}`][0]
              ) {
                // 手动更新上传组件的内部状态
                this.$refs[`${dataName}_${index}`][0].uploadFiles = [
                  ...this.approveForm.settleDetail[index][dataName],
                ];
              }
            });

            this.$message({
              message: "上传成功",
              type: "success",
            });
          } else {
            this.approveForm.invoiceAttaches = [];
            this.$message.error("上传失败!");
          }
        })
        .catch(() => {
          this.$message("上传失败！");
        });
    },

    handleMainExceed(files, fileList) {
      this.$message.warning(`当前限制选择 20 个文件`);
    },

    changeMainFile(file) {
      const maxSize = file.file.size / 1024 / 1024 < this.fileSize;
      if (!maxSize) {
        this.$message.error(`上传文件大小不能超过${this.fileSize}MB`);
        this.$refs.settleAttaches.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("fileName", file.file.name);
      this.onChangeFullscreenLoading(true);
      this.api
        .postImage(
          `/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`,
          formData
        )
        .then((res) => {
          this.onChangeFullscreenLoading(false);

          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.approveForm.settleAttaches.push({
              name: file.file.name,
              path: res.data.data.data,
              fileName: file.file.name,
              batchGuid: item.batchGuid,
            });
            this.$message({
              message: "上传成功",
              type: "success",
            });
          } else {
            this.approveForm.settleAttaches = [];
            this.$message.error("上传失败!");
          }
        })
        .catch(() => {
          this.$message("上传失败！");
        });
    },
    handleMainRemove(file) {
      this.approveForm.settleAttaches.forEach((item, index) => {
        if (item.path == file.path) {
          this.approveForm.settleAttaches.splice(index, 1);
        }
      });
    },
    onPreview(file) {
      let fileSuffix = "";
      if (file.name) {
        fileSuffix = file.name
          ? file.name.substring(file.name.lastIndexOf(".") + 1)
          : "";
      }
      if (file.fileName) {
        fileSuffix = file.fileName
          ? file.fileName.substring(file.fileName.lastIndexOf(".") + 1)
          : "";
      }
      if (fileSuffix == "ofd") {
        return window.open(
          "https://ofd.xdocin.com/view?src=" + encodeURIComponent(file.path)
        );
      }

      if (["png", "jpeg", "jpg", "pdf", "zip", "rar"].includes(fileSuffix)) {
        return window.open(file.path);
      }
      window.open(
        "https://view.officeapps.live.com/op/view.aspx?src=" + file.path
      );
    },

    handleSubExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleSubRemove(file, index, dataName) {
      this.approveForm.settleDetail[index][dataName] = [];
      this.approveForm[dataName] = [];
      this.approveForm.settleDetail = this.approveForm.settleDetail;
      this.$forceUpdate();
    },

    checkForm() {
      const approveForm = this.approveForm;
      if (this.isInvoiced == "N" && !approveForm.settleAttaches.length) {
        this.$message.error("请上传结算单");
        throw new Error("请上传结算单");
      }
      if (!this.paymentSettleList?.length && !approveForm.relevance) {
        this.$message.error("请选择关联流程");
        throw new Error("请选择关联流程");
      }
      if (this.isInvoiced == "N") {
        approveForm.invoiceAttaches = [];
        approveForm.invoiceDate = null;
        approveForm.taxRate = null;
      }
      if (this.isInvoiced == "Y") {
        const settleAttaches = approveForm.settleDetail
          .map((item) => item.settleAttaches)
          .flat()
          .filter((item) => Boolean(item));
        const invoiceAttaches = approveForm.settleDetail
          .map((item) => item.invoiceAttaches)
          .flat()
          .filter((item) => Boolean(item));
        if (approveForm.settleDetail.length !== invoiceAttaches.length) {
          this.$message.error("请上传票据");
          throw new Error("请上传票据");
        }
        if (approveForm.settleDetail.length !== settleAttaches.length) {
          this.$message.error("请上传结算单");
          throw new Error("请上传结算单");
        }
        if (approveForm.settleDetail.length) {
          approveForm.settleDetail.forEach((item) => {
            if (!item.invoiceCategory) {
              this.$message.error("请选择发票类目");
              throw new Error("请选择发票类目");
            }
          });
        }
      }
      if (this.isInvoiced == "Y" && !approveForm.invoiceDate) {
        this.$message.error("请填写开票时间");
        throw new Error("请填写开票时间");
      }
      if (this.isInvoiced == "Y" && !approveForm.taxRate) {
        this.$message.error("请填写发票税率");
        throw new Error("请填写发票税率");
      }
      return true;
    },
    async submitForm() {
      this.checkForm();
      const approveForm = this.approveForm;
      const userInfo = JSON.parse(localStorage.userInfo);
      const settleAttaches = approveForm.settleDetail
        .map((item) => item.settleAttaches)
        .flat()
        .filter((item) => Boolean(item));
      let invoiceAttaches = approveForm.settleDetail
        .map((item) => item.invoiceAttaches)
        .flat()
        .filter((item) => Boolean(item));
      invoiceAttaches = invoiceAttaches.map((item, index) => {
        return {
          ...item,
          invoiceCategory: approveForm.settleDetail[index]?.invoiceCategory,
        };
      });

      const query = {
        approveSuggest: approveForm.approveSuggest,
        approveStaffGuid: userInfo.staffGuid,
        approveGuid: this.approveVO.approveGuid,
        guid: this.$route.query.guid,
        settleAttaches,
        invoiceAttaches,
        invoiceDate: approveForm.invoiceDate, //票据
        taxRate: approveForm.taxRate, //税率
        isInvoiced: this.isInvoiced,
        // relevance: approveForm.relevance, 后端说不需要此字段
        settleGuidList: this.selectSettDoc.map((item) => item.guid),
      };
      if (this.isInvoiced == "N") {
        delete query.invoiceDate;
        delete query.taxRate;
        delete query.settleAttaches;
        delete query.invoiceAttaches;
        query.settleAttaches = approveForm.settleAttaches;
      }
      this.onChangeFullscreenLoading(true);
      this.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/downstream/payment/submit-approve-last`,
          query
        )
        .then((res) => {
          this.onChangeFullscreenLoading(false);

          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.passDialogVisible = false;
            this.$message.success("审批通过！");
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    formatFileName(filename, maxLength = 15) {
      const lastDotIndex = filename.lastIndexOf(".");
      if (lastDotIndex === -1 || filename.length <= maxLength) {
        return filename;
      }
      const name = filename.substring(0, lastDotIndex);
      const extension = filename.substring(lastDotIndex);
      if (name.length > maxLength) {
        return name.substring(0, maxLength) + "..." + extension;
      }
      return filename;
    },
  },
};
</script>

<style scoped lang="less">
.flex {
  display: flex;
}

.items_center {
  align-items: center;
}

.form-title-item {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  margin-left: 16px;
}
.import-step-tip {
  text-align: left;
  font-size: 12px;
  line-height: 20px;
  width: 300px;
}

/* 对话框底部按钮样式 */
.dialog-footer {
  display: flex;
  justify-content: center;
}

.el-form-item {
  margin-bottom: 10px;
}
</style>
